import { useMemo } from 'react';
import { HashLoader } from 'react-spinners';
import { useBuildingIdAtom } from 'stores/building-id-atom';
import { WidgetSizeEnum } from 'types/schema';

import { useGetTransit } from 'api/get-transit';

import * as S from './widget-transportation.styled';
import { WidgetDropdown } from '../widget-dropdown';
import { TransportationStation } from './transportation-station/transportation-station';
import { getStationsCountBasedOnWidgetSize } from './utils';

interface WidgetTransportationProps {
  widgetId: string;
  widgetSize: WidgetSizeEnum;
}

export const WidgetTransportation = ({ widgetId, widgetSize }: WidgetTransportationProps) => {
  const { data, isLoading } = useGetTransit();
  const [buildindId] = useBuildingIdAtom();

  const stationsCount = useMemo(() => getStationsCountBasedOnWidgetSize(widgetSize), [widgetSize]);

  const stationsToRender = useMemo(() => {
    if (!data) return [];

    let filteredStations = data.boards;

    // If buildingId is 805, only show "Journal Square" station
    if (buildindId === 805) {
      filteredStations = data.boards.filter((station) => station.place.name === 'Journal Square');
    }

    return filteredStations.slice(0, stationsCount);
  }, [data, stationsCount, buildindId]);

  const renderTransportation = () => {
    if (isLoading) {
      return (
        <S.SpinnerContainer>
          <HashLoader />
        </S.SpinnerContainer>
      );
    }

    if (!data || data?.boards.length === 0 || stationsToRender.length === 0) {
      return <S.NoStationsWrapper>No stations found</S.NoStationsWrapper>;
    }

    return (
      <S.StationsWrapper>
        {stationsToRender.map((station) => (
          <TransportationStation key={station.place.id} data={station} />
        ))}
      </S.StationsWrapper>
    );
  };

  return (
    <>
      <S.WidgetWrapper>{renderTransportation()}</S.WidgetWrapper>
      <WidgetDropdown widgetId={widgetId} />
    </>
  );
};
